import { useState } from 'react';
import { OAUTH_FLOW_ENABLED } from '../../../../../shared/constants/flipperFlags';
import NotificationActions from '../../../main/actions/NotificationActions';
import dash_api from '../../../main/support/dash_api';

const useAuthenticateLogin = () => {
  const [isOAuthFlowNotEnabledForAccount, setIsOAuthFlowNotEnabledForAccount] = useState<boolean>(false);
  const searchParams = new URLSearchParams(window.location.search);
  const queryParamValue = searchParams.get(OAUTH_FLOW_ENABLED);

  const getOAuthFlowEnabled = (value: string | null) => {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
    return !!window.App?.context?.flipper?.[OAUTH_FLOW_ENABLED];
  };

  const isOAuthFlowEnabled = getOAuthFlowEnabled(queryParamValue);

  const handleAuthenticate = async (emailId: string) => {
    try {
      const endpoint = `/auth/email`;
      const { data } = await dash_api.post(endpoint, { email: emailId });
      if (data.isOAuthEnabled) {
        window.location.href = `/auth/login?emailId=${encodeURIComponent(emailId)}`;
      } else {
        setIsOAuthFlowNotEnabledForAccount(true);
      }
    } catch (error) {
      NotificationActions.showNotification(error?.message || `Failed to get Invoices list`);
    }
  };

  return {
    isOAuthFlowEnabled,
    isOAuthFlowNotEnabledForAccount,
    setIsOAuthFlowNotEnabledForAccount,
    handleAuthenticate,
  };
};

export default useAuthenticateLogin;
